export default __webpack_public_path__ + "static/media/illustration-study-2-m@3x.fbb707ae.webp";